import { render, staticRenderFns } from "./tableTips.vue?vue&type=template&id=0e447c08&"
import script from "./tableTips.vue?vue&type=script&lang=js&"
export * from "./tableTips.vue?vue&type=script&lang=js&"
import style0 from "./tableTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports